import { defineComponent as _defineComponent } from 'vue'
import Checkbox from '@/components/checkbox.vue';
import { useSeasonFeature } from '@/composables/useSeasonFeature';
import { useZohoStrings } from '@/store/zohoStrings';
import { Season } from '@busy-human/hxp-library';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

type Emits = {
	(e: 'close'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'start-registration',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();


const REGISTRATION_PORTAL_LIVE = CONFIG.flags.REGISTRATION_ENABLED;
const seasonReg = useSeasonFeature(Season.Features.REGISTRATION);

const router = useRouter();
const zohoStrings = useZohoStrings();

const emit = __emit;

const termsAccepted = ref(false);

const registrationOpenHtml = computed(() => zohoStrings.strings?.zh_registrationOpen?.rendered || `<h1 id="aboutthelottery">About the Lottery</h1><p>Now that you have picked your trip preferences, there are a few more things to do before we can finalize your registration.</p><p>This is a lottery system, not a checkout. While our system will try to place you on one of your top choices, placement is not guaranteed. For the best chance of being placed on a trip, make sure you have at least 10 preferences with available spots</p>`);
const registrationClosedHtml = computed(() => zohoStrings.strings?.zh_registrationClosed?.rendered || `<h1 id="registrationisntopenyet">Registration isn't open yet</h1><p>Registration is not available for the next season of HXP trips just yet.</p><p>Come back during registration week (November 27-December 1st) to finalize your application</p>`);
const registrationOpenConfirmHtml = computed(() => zohoStrings.strings?.zh_registrationConfirmText?.rendered || '<p>I understand that the lottery will consider my preferences, but placement is not guaranteed.</p>');


const goToRegistration = () => {
	if(termsAccepted.value) router.push("/registration");
};

const __returned__ = { REGISTRATION_PORTAL_LIVE, seasonReg, router, zohoStrings, emit, termsAccepted, registrationOpenHtml, registrationClosedHtml, registrationOpenConfirmHtml, goToRegistration, Checkbox, get useSeasonFeature() { return useSeasonFeature }, get useZohoStrings() { return useZohoStrings }, get Season() { return Season }, computed, ref, get useRouter() { return useRouter } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})